import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import config from 'src/config/config';
import BankContainer from 'src/containers/Bank/BankContainer';
import NewFundContainer from 'src/containers/NewFund/NewFundContainer';
import {
  ADD_BANK_MODAL,
  ADD_SCHOOL_MODAL,
  ADD_CHARITY_MODAL,
  DELETE_SCHOOL_MODAL,
  ADD_FUND_MODAL,
  AUTOMATIC_EDIT_NO_CHANGES_MADE,
  AUTOMATIC_TRANSACTION_DEFER,
  DELETE_CHARITY_MODAL,
  AUTOMATIC_TRANSACTION_DEFER_CANCEL,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS,
  AUTOMATIC_TRANSACTION_DELETE,
  AWARENESS_MODULE_MODAL,
  BALANCES_AS_OF_MODAL,
  APP_TRADE_DATE,
  BUCKET_ROLL,
  DELETE_AUTO_RMD,
  CANCEL_TRADE_CONFIRMATION_MODAL,
  closeModal as closeModalAction,
  COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL,
  CONTRIBUTION_WINDOW_CLOSED_MODAL,
  DISTRIBUTION_TRANSACTIONS,
  EXCHANGE_FROM_FUND_MIN_MAX_MODAL,
  IRA_CONTRIBUTIONS_MODAL,
  IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL,
  IRA_WITHHOLDING_WARNING_MODAL,
  MIN_FUND_ALERT_MODAL,
  PAPERLESS_TERMS_MODAL,
  CONTACT_ACCOUNT_TEAM_MODAL,
  RI2020_WITHHOLDING_DISCLOSURE_MODAL,
  RMD_DISCLOSURE_MODAL,
  ROTH_DAILY_MINIMUM_MAXIMUM,
  REDUCE_AUTO_RMD_DISTRIBUTION_MODAL,
  SELL_DEDUCTION_REVIEW_MODAL,
  SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS,
  SELL_ALL_SHARES_DAILY_LIMIT_MODAL,
  SELL_ALL_SHARES_MODAL,
  SELL_ALL_SHARES_UNCOLLECTED_SHARES,
  SELL_FUND_MIN_MAX_MODAL,
  START_DATE_TOOL_TIP,
  IRA_AUTOMAX_START_DATE_TOOL_TIP,
  STATE_TAX_DISCLOSURE_MODAL,
  STATE_WITHHOLDING_NON_MANDATORY,
  TRANSACTION_LANDING_SELL_FROM_SWEEP,
  REQUIRED_MINIMUM_DISTRIBUTION_MODAL,
  CONFIRM_IRA_DISTRIBUTION_MODAL,
  IRA_AUTO_MAX_CONTRIBUTIONS_MODAL,
  IRA_AUTO_MAX_TOO_MANY_DAYS_MODAL,
  EXCHANGE_RETIREMENT_AGREEMENT,
  FEDERAL_INCOME_TAX_WARNING,
  FINANCIAL_ADVISOR_MODAL,
  MIN_MAX_FINANCIAL_ADVISOR_MODAL,
  RAS_WITHDRAW_THRESHOLD_MODAL,
  ANNUAL_PERCENTAGE_DISCLAIMER,
  PAY_TAX_INFORMATION,
  QCD_DAILY_MIN_MAX_MODAL,
} from 'src/redux/modules/modals/modals.module';
import { getModalProps } from 'src/redux/modules/modals/modals.selectors';
import { getSellWithholdingWarned } from 'src/redux/modules/progress';
import { getSelectedSellFundsList } from 'src/redux/modules/sellTransaction/sellTransaction.selectors';
import { getQuickBuyProductType } from 'src/redux/modules/shoppingCart/shoppingCart.selectors';
import {
  getMandatoryWithholdingStates,
  getNonMandatoryWithholdingStates,
  getUserStateWithholdingRules,
} from 'src/redux/modules/stateWithholding/selectors';
import ExchangingToARetirementAgreement from 'src/components/Exchange/FromAgreementMinAmount/ExchangingToARetirementAgreement';
import { getUserAddress } from 'src/redux/modules/user/PersonalInformation/personalInformation.selectors';
import { dispatchPageLoad } from 'src/redux/utils/analytics-helper';
import {
  isAutoExchange,
  isAutomaticSell,
  isCollegeDistribute,
  isIRAAutoMax,
  isRecurringBuy,
  isSell,
} from 'src/utils/transactions-util';
import AsOfModal from '../AsOfModal/AsOfModal';
import AddSchoolModal from '../CollegeDistribute/CollegeDistributeSteps/AddSchoolModal';
import AddCharityModal from '../QCD/QCDLanding/AddCharityModal';
import QCDDailyMinMax from '../QCD/Modal/QCDDailyMinMax';
import DeleteSchoolModal from '../CollegeDistribute/CollegeDistributeSteps/DeleteSchoolModal';
import AutomaticDefer from '../Automatic/AutomaticDefer/AutomaticDefer';
import AutomaticDeferCancel from '../Automatic/AutomaticDeferCancel/AutomaticDeferCancel';
import AutomaticDelete from '../Automatic/AutomaticDelete/AutomaticDelete';
import DeleteAutoRMDModal from '../Automatic/AutomaticDelete/DeleteAutoRMDModal';
import StartDateToolTip from '../RecurringBuy/StartDateToolTip';
import AdvisorModal from '../AdvisorModal/AdvisorModal';
import IRAAutoMaxStartDateToolTip from '../IRAAutoMax/IRAAutoMaxStartDateToolTip';
import {
  getHasAPP,
  getHasCollegeOnly,
  getHasMD529Only,
  getHasMixedCollegeTypes,
} from '../../redux/modules/productTypes/productType.selectors';
import AutomaticEditNoChanges from '../Automatic/AutomaticEditNoChanges/AutomaticEditNoChanges';
import DeferDeleteFail from '../Automatic/DeferDeleteFail/DeferDeleteFail';
import DeferDeleteSuccess from '../Automatic/DeferDeleteSuccess/DeferDeleteSuccess';
import AddBank from '../Bank/AddBank/AddBank';
import AwarenessModule from '../Buy/BuyFlow/AwarenessModule/AwarenessModule';
import BucketRollInfo from '../Buy/BuyFlow/BucketRollInfo/BucketRollInfo';
import ContributionWindowClosed from '../Buy/BuyFlow/ContributionWindowClosed/ContributionWindowClosed';
import DistributionTransaction from '../Shared/DistributionTransaction/DistributionTransaction';
import IRAContribution from '../Buy/BuyFlow/IRAContribution/IRAContribution';
import PaperlessTerms from '../Buy/BuyFlow/TermsAndAgreements/PaperlessTerms';
import CollegeDistributeFundMinMax from '../CollegeDistribute/CollegeDistributeFundEditor/CollegeDistributeFundMinMax';
import CancelTradeConfirmation from '../Confirmation/CancelTradeConfirmation/CancelTradeConfirmation';
import ExchangeFromFundMinMax from '../Exchange/ExchangeFromFundEditor/ExchangeFromFundMinMax';
import SellFromSweepModal from '../LandingPage/SellFromSweepModal/SellFromSweepModal';
import AddNewFund from '../NewFund/AddNewFund/AddNewFund';
import MinFundAlert from '../NewFund/MinFundAlert/MinFundAlert';
import IRARecurringContributionLimit from '../RecurringBuy/IRARecurringContributionLimit';
import IraWithholdingWarning from '../Sell/IraWithholdingWarning/IraWithholdingWarning';
import ContactAccountTeam from '../Sell/ContactAccountTeam/ContactAccountTeam';
import RMDDisclosure from '../Sell/RMD/RMDDisclosure';
import ReduceAutoRMD from '../QCD/Modal/ReduceAutoRMD.js';
import SellAllSharesClosedToNewInvestors from '../Sell/SellAllShares/SellAllSharesClosedToNewInvestors';
import ConfirmIRADistributionModal from '../Sell/SellAllShares/ConfirmIRADistributionModal';
import SellAllSharesDailyLimitDisclosure from '../Sell/SellAllShares/SellAllSharesDailyLimitDisclosure';
import SellAllSharesDisclosure from '../Sell/SellAllShares/SellAllSharesDisclosure';
import SellAllSharesUncollectedShares from '../Sell/SellAllShares/SellAllSharesUncollectedShares';
import SellFundMinMax from '../Sell/SellFundEditor/SellFundMinMax';
import StateIncomeTaxDisclosure from '../Sell/StateIncomeTaxDisclosure/StateIncomeTaxDisclosure';
import StateWithholdingNonMandatory from '../Sell/StateWithholdingNonMandatory/StateWithholdingNonMandatory';
import CollegeBrandingContainer from '../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import DeleteCharityModal from '../QCD/step1/DeleteCharityModal';
import PayeeTaxInformation from '../Shared/PayeeTaxInformation/PayeeTaxInformation';
import Modal from '../Shared/Modal/Modal';
import FederalIncomeTaxWithholdingWarning from '../Shared/FederalIncomeTaxWithholdingWarning/FederalIncomeTaxWithholdingWarning';
import RI2020WithholdingDisclosureModal from '../Shared/RI2020WithholdingDisclosureModal/RI2020WithholdingDisclosureModal';
import AnnualPercentageDisclaimer from 'src/components/AutoSell/AnnualPercentageDisclaimer/AnnualPercentageDisclaimer.js';
import './ModalsDisplay.scss';
import SellDeductionReviewModal from '../Sell/SellReview/SellDeductionReviewModal/SellDeductionReviewModal';
import AppTradeDateModal from '../AppSell/AppTradeDateModal/AppTradeDateModal';
import RothDailyMinMaxModal from '../RothConversion/common/RothDailyMinMaxModal/RothDailyMinMaxModal';
import RMDModal from '../RothConversion/common/RMDModal/RMDModal';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../redux/modules/authentication/authentication.module.selectors';
import { getHasErrorType } from '../../redux/modules/linkedBanks/linkBank.selectors';
import { checkMFBuyOrExchangeFlow } from '../../utils/funds/shared/shared-fund-notes-utility';
import { getIRAAutoMaxCalculationDataSorted } from '../../redux/modules/funds/IRAAutoMaxCalculation/IRAAutoMaxCalculations.selectors';
import IRAAutoMaxContributionsModal from '../IRAAutoMax/IRAAutoMaxContributionModal/IRAAutoMaxContributionModal';
import AdvisorModalContent from '../Shared/AdvisorModalContent/AdvisorModalContent';
import RasWithdrawThresholdModal from '../Shared/RasWithdrawThresholdModal/RasWithdrawThresholdModal.js';
import IRAAutoMaxTooManyDays from '../IRAAutoMax/IRAAutoMaxTooManyDaysModal/IRAAutoMaxTooManyDaysModal';
import { moduleActions } from '../../redux/modules';
import { scrollElementIntoFullView, isPhone } from '../../utils/dom-utils';

function returnURL() {
  if (
    isRecurringBuy() ||
    isAutoExchange() ||
    isIRAAutoMax() ||
    isAutomaticSell()
  ) {
    return `${config.url}/usis/transactions/automatic`;
  } else {
    return `${config.url}/usis/my-accounts/dashboard`;
  }
}

const isPostLaunch = (dateAndTime) => {
  const currentDate = new Date();
  const launchDate = new Date(dateAndTime);
  return currentDate > launchDate;
};

const ModalsDisplay = ({
  isSalesforceRepEnabled,
  customerWebViewEnabled,
  closeModal,
  collegeOnly,
  md529Only,
  IRALimit,
  sellWithholdingWarned,
  modals,
  modalProps,
  mandatoryWithholdingStates,
  nonMandatoryWithholdingStates,
  selectedSellFundsList,
  routing,
  userAddress,
  userFunds,
  userStateWithholdingRules,
  hasAPP,
  iraAutoMaxContributionData,
  hasMixedCollegeTypes,
  isMobile,
  eVerification,
  linkedBanks,
  actions,
}) => (
  <CollegeBrandingContainer>
    <BankContainer>
      <Modal
        className="e2e-add-bank add-bank"
        clickOutsideCloses={false}
        show={modals[ADD_BANK_MODAL]}
        showBackdrop={!(!customerWebViewEnabled && isSalesforceRepEnabled)}
        showCloseButton={
          !isSalesforceRepEnabled &&
          !(eVerification === 'SUCCESS' || linkedBanks === 'SUCCESS')
        }
        onCloseClick={() => closeModal(ADD_BANK_MODAL)}
      >
        <AddBank
          customerWebViewEnabled={customerWebViewEnabled}
          dispatchPageLoad={dispatchPageLoad}
          hasErrorType={getHasErrorType}
          isSalesforceRep={isSalesforceRepEnabled}
          routing={routing}
        />
      </Modal>
    </BankContainer>

    <Modal
      className={`add-fund ${checkMFBuyOrExchangeFlow() ? 'new-fund' : ''}`}
      modalProps={modals[ADD_FUND_MODAL]}
      show={modals[ADD_FUND_MODAL]}
      onCloseClick={() => closeModal(ADD_FUND_MODAL)}
    >
      <NewFundContainer>
        <AddNewFund />
      </NewFundContainer>
    </Modal>
    <Modal
      modalProps={modals[EXCHANGE_RETIREMENT_AGREEMENT]}
      show={modals[EXCHANGE_RETIREMENT_AGREEMENT]}
      onCloseClick={() => closeModal(EXCHANGE_RETIREMENT_AGREEMENT)}
    >
      <ExchangingToARetirementAgreement
        {...modalProps[EXCHANGE_RETIREMENT_AGREEMENT]}
        closeModal={() => closeModal(EXCHANGE_RETIREMENT_AGREEMENT)}
      />
    </Modal>
    <Modal
      modalProps={modals[CONFIRM_IRA_DISTRIBUTION_MODAL]}
      show={modals[CONFIRM_IRA_DISTRIBUTION_MODAL]}
      onCloseClick={() => closeModal(CONFIRM_IRA_DISTRIBUTION_MODAL)}
    >
      <ConfirmIRADistributionModal
        {...modalProps[CONFIRM_IRA_DISTRIBUTION_MODAL]}
        closeModal={() => closeModal(CONFIRM_IRA_DISTRIBUTION_MODAL)}
      />
    </Modal>

    <Modal
      modalProps={modals[DISTRIBUTION_TRANSACTIONS]}
      show={modals[DISTRIBUTION_TRANSACTIONS]}
      onCloseClick={() => closeModal(DISTRIBUTION_TRANSACTIONS)}
    >
      <DistributionTransaction
        {...modalProps[DISTRIBUTION_TRANSACTIONS]}
        closeModal={() => closeModal(DISTRIBUTION_TRANSACTIONS)}
        proceed={() => closeModal(DISTRIBUTION_TRANSACTIONS)}
      />
    </Modal>

    <Modal
      className="awareness"
      show={modals[AWARENESS_MODULE_MODAL]}
      onCloseClick={() => closeModal(AWARENESS_MODULE_MODAL)}
    >
      <AwarenessModule
        handleAwarenessModule={() => closeModal(AWARENESS_MODULE_MODAL)}
      />
    </Modal>

    <Modal
      className="contribution-window"
      show={modals[CONTRIBUTION_WINDOW_CLOSED_MODAL]}
      onCloseClick={() => closeModal(CONTRIBUTION_WINDOW_CLOSED_MODAL)}
    >
      <ContributionWindowClosed
        IRALimit={IRALimit}
        closeContributionWindowAlert={() =>
          closeModal(CONTRIBUTION_WINDOW_CLOSED_MODAL)
        }
      />
    </Modal>

    <Modal
      className="ira-contribution-list"
      show={modals[IRA_CONTRIBUTIONS_MODAL]}
      onCloseClick={() => closeModal(IRA_CONTRIBUTIONS_MODAL)}
    >
      <IRAContribution
        {...modalProps[IRA_CONTRIBUTIONS_MODAL]}
        IRALimit={IRALimit}
        handleClose={() => closeModal(IRA_CONTRIBUTIONS_MODAL)}
        userFunds={userFunds}
      />
    </Modal>
    <Modal
      className="as-of"
      show={modals[BALANCES_AS_OF_MODAL]}
      onCloseClick={() => closeModal(BALANCES_AS_OF_MODAL)}
    >
      <AsOfModal collegeOnly={collegeOnly} hasAPP={hasAPP} />
    </Modal>
    <Modal
      className="add-school"
      clickOutsideCloses={false}
      show={modals[ADD_SCHOOL_MODAL]}
      onCloseClick={() => closeModal(ADD_SCHOOL_MODAL)}
    >
      <AddSchoolModal closeModal={closeModal} />
    </Modal>
    <Modal
      className="add-charity"
      clickOutsideCloses={false}
      show={modals[ADD_CHARITY_MODAL]}
      showCloseButton={true}
      onCloseClick={() => closeModal(ADD_CHARITY_MODAL)}
    >
      <AddCharityModal
        closeModal={closeModal}
        {...modalProps[ADD_CHARITY_MODAL]}
      />
    </Modal>
    <Modal
      className="delete-school"
      clickOutsideCloses={false}
      show={modals[DELETE_SCHOOL_MODAL]}
      showCloseButton={false}
      onCloseClick={() => closeModal(DELETE_SCHOOL_MODAL)}
    >
      <DeleteSchoolModal closeModal={closeModal} />
    </Modal>
    <Modal
      className="as-of"
      show={modals[APP_TRADE_DATE]}
      onCloseClick={() => closeModal(APP_TRADE_DATE)}
    >
      <AppTradeDateModal />
    </Modal>
    <Modal
      className="cancel-trade"
      show={modals[CANCEL_TRADE_CONFIRMATION_MODAL]}
      onCloseClick={() => closeModal(CANCEL_TRADE_CONFIRMATION_MODAL)}
    >
      <CancelTradeConfirmation closeModal={closeModal} returnURL={returnURL} />
    </Modal>

    <Modal
      className="paperless-terms"
      show={modals[PAPERLESS_TERMS_MODAL]}
      onCloseClick={() => closeModal(PAPERLESS_TERMS_MODAL)}
    >
      <PaperlessTerms closeModal={closeModal} />
    </Modal>

    <Modal
      clickOutsideCloses={sellWithholdingWarned}
      show={modals[IRA_WITHHOLDING_WARNING_MODAL]}
      showCloseButton={sellWithholdingWarned}
      onCloseClick={() => closeModal(IRA_WITHHOLDING_WARNING_MODAL)}
    >
      <IraWithholdingWarning {...modalProps[IRA_WITHHOLDING_WARNING_MODAL]} />
    </Modal>
    <Modal
      className="state-withholding-non-mandatory-modal-display"
      clickOutsideCloses={true}
      show={modals[STATE_WITHHOLDING_NON_MANDATORY]}
      showCloseButton={true}
      onCloseClick={() => closeModal(STATE_WITHHOLDING_NON_MANDATORY)}
    >
      <StateWithholdingNonMandatory
        {...modalProps[STATE_WITHHOLDING_NON_MANDATORY]}
      />
    </Modal>
    <Modal
      className="state-withholding-non-mandatory-modal-display federal-withholding-warning"
      clickOutsideCloses={true}
      show={modals[FEDERAL_INCOME_TAX_WARNING]}
      showCloseButton={true}
      onCloseClick={() => {
        actions.onClickScroll(2, 'roth-conversion-tax-withholding-step');
        closeModal(FEDERAL_INCOME_TAX_WARNING);
      }}
    >
      <FederalIncomeTaxWithholdingWarning
        {...modalProps[FEDERAL_INCOME_TAX_WARNING]}
      />
    </Modal>
    <Modal
      className="contact-account-team-modal"
      clickOutsideCloses={true}
      show={modals[CONTACT_ACCOUNT_TEAM_MODAL]}
      showCloseButton={true}
      onCloseClick={() => closeModal(CONTACT_ACCOUNT_TEAM_MODAL)}
    >
      <ContactAccountTeam {...modalProps[CONTACT_ACCOUNT_TEAM_MODAL]} />
    </Modal>

    <Modal
      className="ri2020-withholding-disclosure"
      clickOutsideCloses={false}
      show={modals[RI2020_WITHHOLDING_DISCLOSURE_MODAL]}
      showCloseButton={false}
      onCloseClick={() => closeModal(RI2020_WITHHOLDING_DISCLOSURE_MODAL)}
    >
      <RI2020WithholdingDisclosureModal />
    </Modal>

    <Modal
      className="ri2020-withholding-disclosure"
      clickOutsideCloses={false}
      show={modals[ANNUAL_PERCENTAGE_DISCLAIMER]}
      showCloseButton={false}
      onCloseClick={() => closeModal(ANNUAL_PERCENTAGE_DISCLAIMER)}
    >
      <AnnualPercentageDisclaimer closeModal={closeModal} />
    </Modal>

    <Modal
      clickOutsideCloses
      showCloseButton
      className="state-income-tax-disclosure-modals-display"
      show={modals[STATE_TAX_DISCLOSURE_MODAL]}
      onCloseClick={() => closeModal(STATE_TAX_DISCLOSURE_MODAL)}
    >
      <StateIncomeTaxDisclosure
        closeStateIncomeTaxDisclosure={() =>
          closeModal(STATE_TAX_DISCLOSURE_MODAL)
        }
        mandatoryWithholdingStates={mandatoryWithholdingStates}
        nonMandatoryWithholdingStates={nonMandatoryWithholdingStates}
        stateWithholdingRules={userStateWithholdingRules}
        {...modalProps[STATE_TAX_DISCLOSURE_MODAL]}
      />
    </Modal>

    <Modal
      className="sell-all-shares-closed-to-new-investors"
      clickOutsideCloses={false}
      show={modals[SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS]}
      showCloseButton={false}
      onCloseClick={() => closeModal(SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS)}
    >
      <SellAllSharesClosedToNewInvestors
        {...modalProps[SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      className="sell-all-shares-daily-limit-modal"
      clickOutsideCloses={false}
      show={modals[SELL_ALL_SHARES_DAILY_LIMIT_MODAL]}
      showCloseButton={false}
      onCloseClick={() => closeModal(SELL_ALL_SHARES_DAILY_LIMIT_MODAL)}
    >
      <SellAllSharesDailyLimitDisclosure
        {...modalProps[SELL_ALL_SHARES_DAILY_LIMIT_MODAL]}
        closeModal={closeModal}
        customerWebViewEnabled={customerWebViewEnabled}
        isSalesforceRepEnabled={isSalesforceRepEnabled}
      />
    </Modal>

    <Modal
      className="sell-deduction-review"
      modalProps={modals[SELL_DEDUCTION_REVIEW_MODAL]}
      show={modals[SELL_DEDUCTION_REVIEW_MODAL]}
      onCloseClick={() => closeModal(SELL_DEDUCTION_REVIEW_MODAL)}
    >
      <SellDeductionReviewModal
        {...modalProps[SELL_DEDUCTION_REVIEW_MODAL]}
        closeModal={closeModal}
        customerWebViewEnabled={customerWebViewEnabled}
        isSalesforceRepEnabled={isSalesforceRepEnabled}
      />
    </Modal>

    <Modal
      className="sell-all-shares-modal"
      clickOutsideCloses={false}
      show={modals[SELL_ALL_SHARES_MODAL]}
      showCloseButton={false}
      onCloseClick={() => closeModal(SELL_ALL_SHARES_MODAL)}
    >
      <SellAllSharesDisclosure
        {...modalProps[SELL_ALL_SHARES_MODAL]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      className="sell-all-shares-uncollected-shares-modal"
      clickOutsideCloses={false}
      show={modals[SELL_ALL_SHARES_UNCOLLECTED_SHARES]}
      showCloseButton={false}
      onCloseClick={() => closeModal(SELL_ALL_SHARES_UNCOLLECTED_SHARES)}
    >
      <SellAllSharesUncollectedShares
        {...modalProps[SELL_ALL_SHARES_UNCOLLECTED_SHARES]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      showCloseButton
      className="sell-fund-min-max"
      show={modals[SELL_FUND_MIN_MAX_MODAL]}
      onCloseClick={() => closeModal(SELL_FUND_MIN_MAX_MODAL)}
    >
      <SellFundMinMax
        {...modalProps[SELL_FUND_MIN_MAX_MODAL]}
        closeModal={closeModal}
        selectedSellFundsList={selectedSellFundsList}
      />
    </Modal>

    <Modal
      showCloseButton
      className="exchange-from-fund-min-max"
      show={modals[EXCHANGE_FROM_FUND_MIN_MAX_MODAL]}
      onCloseClick={() => closeModal(EXCHANGE_FROM_FUND_MIN_MAX_MODAL)}
    >
      <ExchangeFromFundMinMax
        {...modalProps[EXCHANGE_FROM_FUND_MIN_MAX_MODAL]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      showCloseButton
      className="sell-fund-min-max"
      show={modals[COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL]}
      onCloseClick={() => closeModal(COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL)}
    >
      <CollegeDistributeFundMinMax
        {...modalProps[COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL]}
        closeModal={closeModal}
        md529Only={md529Only}
        selectedSellFundsList={selectedSellFundsList}
      />
    </Modal>

    <Modal
      clickOutsideCloses
      showCloseButton
      className="rmd-disclosure"
      show={modals[RMD_DISCLOSURE_MODAL]}
      onCloseClick={() => closeModal(RMD_DISCLOSURE_MODAL)}
    >
      <RMDDisclosure
        closeRMDDisclosure={() => closeModal(RMD_DISCLOSURE_MODAL)}
        isPostLaunch={isPostLaunch}
      />
    </Modal>

    <Modal
      clickOutsideCloses
      showCloseButton
      className="rmd-disclosure-modal"
      show={modals[REDUCE_AUTO_RMD_DISTRIBUTION_MODAL]}
      onCloseClick={() => closeModal(REDUCE_AUTO_RMD_DISTRIBUTION_MODAL)}
    >
      <ReduceAutoRMD
        closeReduceAutoRMD={() =>
          closeModal(REDUCE_AUTO_RMD_DISTRIBUTION_MODAL)
        }
      />
    </Modal>

    {/*  This Modal is no longer in use*/}
    {/*<Modal*/}
    {/*  className="ira-contribution-list"*/}
    {/*  show={modals[TRANSACTION_POLICY_MODAL]}*/}
    {/*  onCloseClick={() => closeModal(TRANSACTION_POLICY_MODAL)}*/}
    {/*>*/}
    {/*  <TransactionPolicyTable*/}
    {/*    handleClose={() => closeModal(TRANSACTION_POLICY_MODAL)}*/}
    {/*  />*/}
    {/*</Modal>*/}
    <Modal
      showCloseButton
      className="ira-recurring-contribution-limit"
      show={modals[IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL]}
      onCloseClick={() => closeModal(IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL)}
    >
      <IRARecurringContributionLimit
        {...modalProps[IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL]}
        IRALimit={IRALimit}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      showCloseButton
      className="start-date-tool-tip"
      show={modals[START_DATE_TOOL_TIP]}
      onCloseClick={() => closeModal(START_DATE_TOOL_TIP)}
    >
      <StartDateToolTip />
    </Modal>

    <Modal
      showCloseButton
      className="start-date-tool-tip"
      show={modals[IRA_AUTOMAX_START_DATE_TOOL_TIP]}
      onCloseClick={() => closeModal(IRA_AUTOMAX_START_DATE_TOOL_TIP)}
    >
      <IRAAutoMaxStartDateToolTip />
    </Modal>

    <Modal
      showCloseButton
      className="bucket-roll-tool-tip"
      show={modals[BUCKET_ROLL]}
      onCloseClick={() => closeModal(BUCKET_ROLL)}
    >
      <BucketRollInfo closeModal={closeModal} />
    </Modal>

    <Modal
      showCloseButton
      className="automatic-transaction-delete"
      show={modals[AUTOMATIC_TRANSACTION_DELETE]}
      onCloseClick={() => closeModal(AUTOMATIC_TRANSACTION_DELETE)}
    >
      <AutomaticDelete
        dispatchPageLoad={dispatchPageLoad}
        {...modalProps[AUTOMATIC_TRANSACTION_DELETE]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      showCloseButton
      className="automatic-transaction-defer"
      show={modals[AUTOMATIC_TRANSACTION_DEFER]}
      onCloseClick={() => closeModal(AUTOMATIC_TRANSACTION_DEFER)}
    >
      <AutomaticDefer
        dispatchPageLoad={dispatchPageLoad}
        {...modalProps[AUTOMATIC_TRANSACTION_DEFER]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      showCloseButton
      className="automatic-transaction-defer"
      show={modals[AUTOMATIC_TRANSACTION_DEFER_CANCEL]}
      onCloseClick={() => closeModal(AUTOMATIC_TRANSACTION_DEFER_CANCEL)}
    >
      <AutomaticDeferCancel
        dispatchPageLoad={dispatchPageLoad}
        {...modalProps[AUTOMATIC_TRANSACTION_DEFER_CANCEL]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      showCloseButton
      className="automatic-transaction-defer-delete-success"
      show={modals[AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS]}
      onCloseClick={() =>
        closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS)
      }
    >
      <DeferDeleteSuccess
        dispatchPageLoad={dispatchPageLoad}
        {...modalProps[AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      showCloseButton
      className="automatic-transaction-defer-delete-success defer-delete-status"
      show={modals[AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL]}
      onCloseClick={() => closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL)}
    >
      <DeferDeleteFail
        dispatchPageLoad={dispatchPageLoad}
        {...modalProps[AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL]}
        closeModal={closeModal}
      />
    </Modal>

    <Modal
      className="automatic-transaction-defer-delete-success defer-delete-status"
      clickOutsideCloses={false}
      show={modals[AUTOMATIC_EDIT_NO_CHANGES_MADE]}
      showCloseButton={false}
      onCloseClick={() => closeModal(AUTOMATIC_EDIT_NO_CHANGES_MADE)}
    >
      <AutomaticEditNoChanges
        {...modalProps[AUTOMATIC_EDIT_NO_CHANGES_MADE]}
        closeModal={closeModal}
      />
    </Modal>
    <Modal
      className="transaction-landing-sell-from-sweep select-sweep-account"
      show={modals[TRANSACTION_LANDING_SELL_FROM_SWEEP]}
      onCloseClick={() => closeModal(TRANSACTION_LANDING_SELL_FROM_SWEEP)}
    >
      <SellFromSweepModal />
    </Modal>
    <Modal
      className="min-fund-alert"
      show={modals[MIN_FUND_ALERT_MODAL]}
      onCloseClick={() => closeModal(MIN_FUND_ALERT_MODAL)}
    >
      <MinFundAlert
        {...modalProps[MIN_FUND_ALERT_MODAL]}
        closeModal={() => closeModal(MIN_FUND_ALERT_MODAL)}
      />
    </Modal>

    <Modal
      className="roth-daily-min-max-modal"
      show={modals[ROTH_DAILY_MINIMUM_MAXIMUM]}
      onCloseClick={() => closeModal(ROTH_DAILY_MINIMUM_MAXIMUM)}
    >
      <RothDailyMinMaxModal
        {...modalProps[ROTH_DAILY_MINIMUM_MAXIMUM]}
        closeModal={() => closeModal(ROTH_DAILY_MINIMUM_MAXIMUM)}
      />
    </Modal>

    <Modal
      className="required-minimum-distribution-modal"
      clickOutsideCloses={false}
      show={modals[REQUIRED_MINIMUM_DISTRIBUTION_MODAL]}
      showCloseButton={false}
    >
      <RMDModal
        {...modalProps[REQUIRED_MINIMUM_DISTRIBUTION_MODAL]}
        closeModal={() => closeModal(REQUIRED_MINIMUM_DISTRIBUTION_MODAL)}
        customerWebViewEnabled={customerWebViewEnabled}
        isSalesforceRepEnabled={isSalesforceRepEnabled}
      />
    </Modal>

    <Modal
      className="roth-daily-min-max-modal"
      clickOutsideCloses={false}
      show={modals[DELETE_CHARITY_MODAL]}
      showCloseButton={false}
    >
      <DeleteCharityModal
        closeModal={() => closeModal(DELETE_CHARITY_MODAL)}
        {...modalProps[DELETE_CHARITY_MODAL]}
      />
    </Modal>

    <Modal
      className="financial-advisor-modal"
      show={modals[FINANCIAL_ADVISOR_MODAL]}
      onCloseClick={() => closeModal(FINANCIAL_ADVISOR_MODAL)}
    >
      <AdvisorModal
        description={AdvisorModalContent.contactAdvisorDescription}
        isMobile={isMobile}
        title={AdvisorModalContent.contactAdvisorTitle}
      />
    </Modal>

    <Modal
      className="min-max-financial-advisor-modal"
      show={modals[DELETE_AUTO_RMD]}
      onCloseClick={() => closeModal(DELETE_AUTO_RMD)}
    >
      <DeleteAutoRMDModal closeModal={closeModal} />
    </Modal>

    <Modal
      className="min-max-financial-advisor-modal"
      show={modals[MIN_MAX_FINANCIAL_ADVISOR_MODAL]}
      onCloseClick={() => closeModal(MIN_MAX_FINANCIAL_ADVISOR_MODAL)}
    >
      <AdvisorModal
        description={AdvisorModalContent.minMaxContactAdvisorDescription}
        {...modalProps[MIN_MAX_FINANCIAL_ADVISOR_MODAL]}
        isMobile={isMobile}
        title={AdvisorModalContent.minMaxContactAdvisorTitle}
      />
    </Modal>

    <Modal
      className="ras-withdraw-threshold-modal"
      show={modals[RAS_WITHDRAW_THRESHOLD_MODAL]}
      onCloseClick={() => closeModal(RAS_WITHDRAW_THRESHOLD_MODAL)}
    >
      <RasWithdrawThresholdModal />
    </Modal>
    <Modal
      className="payee-tax-modal"
      show={modals[PAY_TAX_INFORMATION]}
      onCloseClick={() => closeModal(PAY_TAX_INFORMATION)}
    >
      <PayeeTaxInformation
        {...modals[PAY_TAX_INFORMATION]}
        closeModal={() => closeModal(PAY_TAX_INFORMATION)}
      />
    </Modal>
    <Modal
      className="ira-automax-contributions-modal"
      clickOutsideCloses={true}
      show={modals[IRA_AUTO_MAX_CONTRIBUTIONS_MODAL]}
      showCloseButton={true}
      onCloseClick={() => closeModal(IRA_AUTO_MAX_CONTRIBUTIONS_MODAL)}
    >
      <IRAAutoMaxContributionsModal
        {...modalProps[IRA_AUTO_MAX_CONTRIBUTIONS_MODAL]}
        closeModal={() => closeModal(IRA_AUTO_MAX_CONTRIBUTIONS_MODAL)}
        contributionData={iraAutoMaxContributionData}
        customerWebViewEnabled={customerWebViewEnabled}
        isSalesforceRepEnabled={isSalesforceRepEnabled}
      />
    </Modal>
    <Modal
      className="ira-automax-too-many-days-modal"
      clickOutsideCloses={true}
      show={modals[IRA_AUTO_MAX_TOO_MANY_DAYS_MODAL]}
      showCloseButton={true}
      onCloseClick={() => closeModal(IRA_AUTO_MAX_TOO_MANY_DAYS_MODAL)}
    >
      <IRAAutoMaxTooManyDays
        {...modalProps[IRA_AUTO_MAX_TOO_MANY_DAYS_MODAL]}
        closeModal={() => closeModal(IRA_AUTO_MAX_TOO_MANY_DAYS_MODAL)}
      />
    </Modal>
    <Modal
      className="ira-automax-too-many-days-modal"
      clickOutsideCloses={true}
      show={modals[QCD_DAILY_MIN_MAX_MODAL]}
      showCloseButton={true}
      onCloseClick={() => closeModal(QCD_DAILY_MIN_MAX_MODAL)}
    >
      <QCDDailyMinMax closeModal={() => closeModal(QCD_DAILY_MIN_MAX_MODAL)} />
    </Modal>
    <Modal
      className="ira-automax-contributions-modal"
      clickOutsideCloses={true}
      show={modals[IRA_AUTO_MAX_CONTRIBUTIONS_MODAL]}
      showCloseButton={true}
      onCloseClick={() => closeModal(IRA_AUTO_MAX_CONTRIBUTIONS_MODAL)}
    >
      <IRAAutoMaxContributionsModal
        {...modalProps[IRA_AUTO_MAX_CONTRIBUTIONS_MODAL]}
        closeModal={() => closeModal(IRA_AUTO_MAX_CONTRIBUTIONS_MODAL)}
        contributionData={iraAutoMaxContributionData}
        customerWebViewEnabled={customerWebViewEnabled}
        isSalesforceRepEnabled={isSalesforceRepEnabled}
      />
    </Modal>
  </CollegeBrandingContainer>
);

const mapStateToProps = (state) => {
  const {
    existingBanks: { existingBanks },
    IRALimit,
    modals,
    personalInformation,
    shoppingCart: { selectedBank },
    routing,
    userFunds,
    eVerification,
    linkedBanks,
  } = state;
  return {
    getHasErrorType: getHasErrorType(state),
    isSalesforceRepEnabled: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    collegeOnly: getHasCollegeOnly(state),
    md529Only: getHasMD529Only(state),
    hasAPP: getHasAPP(state),
    hasMixedCollegeTypes: getHasMixedCollegeTypes(state),
    isMobile: isPhone(),
    existingBanks,
    IRALimit,
    mandatoryWithholdingStates: getMandatoryWithholdingStates(state),
    nonMandatoryWithholdingStates: getNonMandatoryWithholdingStates(state),
    // Todo: Refactor to add selected sell fund list lookup selector for cases where selectedSellFundList is used to get the currently selected fund
    selectedSellFundsList:
      isSell() || isCollegeDistribute() || isAutomaticSell()
        ? getSelectedSellFundsList(state)
        : [],
    sellWithholdingWarned: getSellWithholdingWarned(state),
    userAddress: getUserAddress(state),
    userStateWithholdingRules: getUserStateWithholdingRules(state),
    quickBuyProductType: getQuickBuyProductType(state),
    modals,
    modalProps: getModalProps(state),
    personalInformation,
    selectedBank,
    routing,
    userFunds,
    iraAutoMaxContributionData: getIRAAutoMaxCalculationDataSorted(state),
    eVerification,
    linkedBanks,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ closeModal: closeModalAction }, dispatch),
  actions: {
    onClickScroll: (step, element) => {
      dispatch(moduleActions.setProgress(step));
      scrollElementIntoFullView(element, 15);
    },
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ModalsDisplay
);
